import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type PanelDimensionFeatureParams = FeatureHoookParams;
export const useShowPanelInsideDimensionFeature = (_params: PanelDimensionFeatureParams = {}): Feature<boolean> => {
	const [controller] = useDesign<Controller, { options: { showPanelInsideDimensions: boolean }}>();

	useSubscription(controller, false, [['layer-option-panel-inside-dimension', '*']]);

	const controllerSupportsFeature = (controller?.options?.showPanelInsideDimensions ?? null) !== null;
	const showLayer = controller?.options?.showPanelInsideDimensions ?? true;

	const tooltip = (() => {
		const showHide = showLayer ? lang.layer.tooltip.hide : lang.layer.tooltip.show;
		return `${showHide} ${lang.layer.label.panelInsideDimensions} ${lang.layer.layer}`;
	})();

	return {
		name: 'showPanelInsideDimensions',
		label: lang.layer.label.panelInsideDimensions,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled: !controllerSupportsFeature,
		value: showLayer,
		hidden: false,
		handler: () => {
			if (controller) {
				controller.options.showPanelInsideDimensions = !showLayer;
			}
		}
	};
};
